import type { auth as en } from '@/i18n/locales/en/auth';
import type { Translation } from '@/i18n/types';

export const auth: Translation<typeof en> = {
  signInFailed: 'Échec de la connexion',
  checkingSession: 'Vérification de votre session…',
  redirectingToSignIn: 'Redirection vers la connexion…',
  signingIn: 'Connexion en cours…',
  backToDashboard: 'Retour au tableau de bord',
};
